import Home from "../views/index.vue";
import Layout from '../components/layout.vue'

const routes = [
    {
        name: 'layout',
        path: '/',
        redirect: '/index',
        component: Layout,
        children: [
            // 首页
            {
                path: '/index/:index',
                name: 'index',
                component: () => import(/* webpackChunkName: "user" */ '@/views/index'),
            },
            // 关于我们
            {
                path: '/foundation',
                name: 'foundation',
                component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/foundation'),
                children: [
                    {
                        path: '/foundation',
                        name: 'introduce',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/introduce'),
                    },
                    {
                        path: '/foundation/purpose',
                        name: 'purpose',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/purpose'),
                    },
                    {
                        path: '/foundation/constitutionSystem',
                        name: 'constitutionSystem',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/constitutionSystem'),
                    },
                    {
                        path: '/foundation/organization',
                        name: 'organization',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/organization'),
                    },
                    {
                        path: '/foundation/councilMembers',
                        name: 'councilMembers',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/aboutUs/councilMembers'),
                    },
                ]
            },
            // 机构项目
            {
                path: '/projects',
                name: 'projects',
                component: () => import(/* webpackChunkName: "user" */ '@/views/institutionalProjects/projects'),
                children: [
                    {
                        path: '/projects',
                        name: 'safetyClassroom',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/institutionalProjects/safetyClassroom'),
                    },
                    {
                        path: '/projects/hopeStudy',
                        name: 'hopeStudy',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/institutionalProjects/hopeStudy'),
                    },
                    {
                        path: '/projects/hopeAction',
                        name: 'hopeAction',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/institutionalProjects/hopeAction'),
                    },
                    {
                        path: '/projects/detail',
                        name: 'projectDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/institutionalProjects/projectDetail'),
                    },
                ]
            },
            // 信息公示
            {
                path: '/information',
                name: 'information',
                component: () => import(/* webpackChunkName: "user" */ '@/views/information/information'),
                children: [
                    {
                        path: '/information',
                        name: 'monthly',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/monthly'),
                    },
                    {
                        path: '/information/yearly',
                        name: 'yearly',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/yearly'),
                    },
                    {
                        path: '/information/meeting',
                        name: 'meeting',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/meeting'),
                    },
                    {
                        path: '/information/auditReport',
                        name: 'auditReport',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/auditReport'),
                    },
                    {
                        path: '/information/management',
                        name: 'management',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/management'),
                    },
                    {
                        path: '/information/monthly/detail',
                        name: 'monthlyDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/monthlyDetail'),
                    },
                    {
                        path: '/information/year/detail',
                        name: 'yearDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/yearDetail'),
                    },
                    {
                        path: '/information/meet/detail',
                        name: 'meetDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/meetDetail'),
                    },
                    {
                        path: '/information/report/detail',
                        name: 'reportDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/reportDetail'),
                    },
                    {
                        path: '/information/management/detail',
                        name: 'managementDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/information/managementDetail'),
                    },
                ]
            },
            // 新闻中心
            {
                path: '/newcenter',
                name: 'newcenter',
                component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/newCenter'),
                children: [
                    {
                        path: '/newcenter',
                        name: 'dynamics',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/dynamics'),
                    },
                    {
                        path: '/newCenter/media',
                        name: 'media',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/media'),
                    },
                    {
                        path: '/newCenter/industry',
                        name: 'industry',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/industry'),
                    },
                    {
                        path: '/newCenter/honor',
                        name: 'honor',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/honor'),
                    },
                    {
                        path: '/newCenter/activities',
                        name: 'activities',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/activities'),
                    },
                    {
                        path: '/newCenter/newcenter/detail',
                        name: 'newcenterDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/newCenterDetail'),
                    },
                    // {
                    //     path: '/newCenter/year/detail',
                    //     name: 'yearDetail',
                    //     component: () => import(/* webpackChunkName: "user" */ '@/views/newCenter/yearDetail'),
                    // },
                ]
            },
            // 志愿之家
            {
                path: '/volunteer',
                name: 'volunteer',
                component: () => import(/* webpackChunkName: "user" */ '@/views/volunteer/volunteer'),
                children: [
                    {
                        path: '/volunteer',
                        name: 'demeanor',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/volunteer/demeanor'),
                    },
                    {
                        path: '/volunteer/station',
                        name: 'station',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/volunteer/station'),
                    },
                    {
                        path: '/volunteer/demeanor/detail',
                        name: 'demeanorDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/volunteer/demeanorDetail'),
                    },
                    {
                        path: '/volunteer/station/detail',
                        name: 'stationDetail',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/volunteer/stationDetail'),
                    },
                ]
            },
            // 捐款
            {
                path: '/contribution',
                name: 'contribution',
                component: () => import(/* webpackChunkName: "user" */ '@/views/contribution/contribution'),
                children: [
                    {
                        path: '/contribution',
                        name: 'myMoney',
                        component: () => import(/* webpackChunkName: "user" */ '@/views/contribution/myMoney'),
                    },
                ]
            },
        ]
    },
    {
        name: "home",
        path: "/index",
        component: Home
    },
];
export default routes;

